const config = window.__PWA_CONFIG__;

export const colors = {
  primary: '#fc5c65',
  secondary: '#4ecdc4',
  black: '#000',
  white: '#fff',
  medium: '#6e6969',
  light: config?.background_color || '#f8f4f4',
  dark: '#0c0c0c',
  danger: '#ff5252',
  seagreen: '#2e8b57',
  dodgerblue: '#1e90ff',
  gold: '#ffd700',
  lightpink: '#ffb6c1',
  lightgray: '#d3d3d3',
  lightgreen: '#90ee90',
  ticket: '#2e8b57',
  utility: '#1e90ff',
  souvenir: '#ffb6c1',
  voucher: '#ffd700',
  cashdeal: '#90ee90',
  darkcyan: '#008b8b',
  mediumturquoise: '#48d1cc',
  skyblue: '#87ceeb',
  steelblue: '#4682b4',
  cadetblue: '#5f9ea0',
  toc_blue: config?.theme_color || '#1d1160',
  toc_pink: config?.button_color || '#ec008c',
};

export type ColorName = keyof typeof colors;

export const images = {
  get logo() {
    return window.__PWA_CONFIG__?.logo_image || '';
  },
  get background() {
    return window.__PWA_CONFIG__?.background_image || '';
  },
  get coinPurchaseSponsor() {
    return window.__PWA_CONFIG__?.coin_purchase_sponsor || '';
  },
};

export default colors;
